<template>
    <div>
        <div ref="drag-container" id="mix-drag-container" @dragover="dragOver">
            <div ref="waveform" :class="['waveform', {raw: isRaw}]" style="overflow: hidden;">
                <canvas ref="mixpoints" id="mixpoints"></canvas>
            </div>
            <a href="#" class="mix fade-in " draggable @dragstart="fadeInDragStart" @drag="fadeInDrag"
               @dragend="emitPositionChanged" v-tooltip="{data: 'Fade in', arrowPosition: 'top'}"></a>
            <a href="#" class="mix intro " draggable @dragstart="introDragStart" @drag="introDrag"
               @dragend="emitPositionChanged" v-tooltip="{data: 'Intro', arrowPosition: 'bottom'}"></a>
            <a href="#" class="mix extro " draggable @dragstart="extroDragStart" @drag="extroDrag"
               @dragend="emitPositionChanged" v-tooltip="{data: 'Outro', arrowPosition: 'bottom'}"></a>
            <a href="#" class="mix fade-out " draggable @dragstart="fadeOutDragStart" @drag="fadeOutDrag"
               @dragend="emitPositionChanged" v-tooltip="{data: 'Fade out', arrowPosition: 'top'}"></a>
            <a href="#" class="mix cue " draggable @dragstart="cueDragStart" @drag="cueDrag" v-tooltip="{data: 'Cue', arrowPosition: 'top'}"></a>
            <a href="#" class="mix mixpoint " draggable @dragstart="mixPointDragStart" @drag="mixPointDrag"
               @dragend="emitPositionChanged" v-tooltip="{data: 'Mix point', arrowPosition: 'bottom'}"></a>
        </div>
        <div id="wave-timeline"></div>
    </div>
</template>

<style lang="scss" scoped>
    #mix-drag-container {
        position: relative;
        padding: 10px 0;
    }
    a {
    padding-right: 12px;
     }
</style>

<script>
    import Constants from '@/store/constants'
    import WaveSurfer from 'wavesurfer.js/dist/wavesurfer.min';
    import RegionPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.regions.min';
    import TimelinePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.timeline.min';
    import CursorPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.cursor.min';

    export default {
        name: 'WaveForm',
        components: {},
        computed: {
            Constants: () => Constants,
            primaryColor: function () {
                return Constants.colors[Constants.context.name].primary
            }
        },
        watch: {
            fadeInStart() {
                this.positions.fadeInStart = this.fadeInStart;
            },
            fadeInStop() {
                this.positions.fadeInStop = this.fadeInStop
            },
            fadeOutStart() {
                this.positions.fadeOutStart = this.fadeOutStart
            },
            fadeOutStop() {
                this.positions.fadeOutStop = this.fadeOutStop
            },
            mixPoint() {
                this.positions.mixPoint = this.mixPoint
            },
            'positions.fadeInStart': 'drawFadeLine',
            'positions.fadeInStop': 'drawFadeLine',
            'positions.fadeOutStart': 'drawFadeLine',
            'positions.fadeOutStop': 'drawFadeLine',
            'positions.cue': 'drawMixPoints',
            'positions.mixPoint': 'drawMixPoints',
            'blob': 'createWaveForm'
        },
        props: {
            // track: Object,
            blob: Blob,
            fadeInStart: {type: Number, default: 0},
            fadeInStop: {type: Number, default: 0},
            fadeOutStart: {type: Number, default: 0},
            fadeOutStop: {type: Number, default: 0},
            mixPoint: {type: Number, default: 0},
        },
        data() {
            return {
                secondsPerPixel: 0,
                cuePosition: 2000,
                waveIsReady: false,
                isRaw: false,
                dragData: {
                    enableRegionRefresh: false
                },
                ctx: null,
                positions: {
                    fadeInStart: this.fadeInStart,
                    fadeInStop: this.fadeInStop,
                    fadeOutStart: this.fadeOutStart,
                    fadeOutStop: this.fadeOutStop,
                    mixPoint: this.mixPoint,
                    cue: 1000
                },
                cursorStyle: {
                    'background-color': '#666F77',
                    'color': '#fff',
                    'padding': '2px',
                    'font-size': '10px',
                    'z-index': '20',
                    'visibility': 'visible'
                }
            }
        },
        mounted() {
            this.fadeInDragHandle = this.$refs["drag-container"].querySelector('.mix.fade-in')
            this.introDragHandle = this.$refs["drag-container"].querySelector('.mix.intro')
            this.mixPointDragHandle = this.$refs["drag-container"].querySelector('.mix.mixpoint')
            this.extroDragHandle = this.$refs["drag-container"].querySelector('.mix.extro')
            this.fadeOutDragHandle = this.$refs["drag-container"].querySelector('.mix.fade-out')
            this.cueDragHandle = this.$refs["drag-container"].querySelector('.mix.cue')
        },
        methods: {
            dragOver(e) {
                // Used to track mouse position when dragging cursor
                //console.log("Dragover : ", e);
                this.dragData = Object.assign(this.dragData, {
                    clientX: e.clientX, clientY: e.clientY
                })
            },

            //----------------------------------------------------------------------
            emitPositionChanged() {
                console.log('emitPositionChanged' , this.positions)
                this.positions.fadeInStart = parseInt(this.positions.fadeInStart);
                this.positions.fadeInStop = parseInt(this.positions.fadeInStop);
                this.positions.mixPoint = parseInt(this.positions.mixPoint);
                this.positions.fadeOutStart = parseInt(this.positions.fadeOutStart);
                this.positions.fadeOutStop = parseInt(this.positions.fadeOutStop);
                console.log('emitPositionChanged' , this.positions)
                this.$emit('positions-changed', this.positions);
            },
            //----------------------------------------------------------------------
            reset() {
                this.waveIsReady = false
                if (!this.introDragHandle) return
                if (this.wavesurfer) {
                    this.wavesurfer.stop()
                    this.wavesurfer.destroy()
                }
                // this.wavesurfer &&
            },
            initRegions() {
                //console.log("Init regions");
                this.wavesurfer.clearRegions()
                this.wavesurfer.addRegion(
                    {
                        id: "fullTrackRegion",
                        start: 0,
                        end: this.wavesurfer.getDuration(),
                        drag: false,
                        resize: false,
                        color: "transparent"
                    });
                this.wavesurfer.addRegion(
                    {
                        id: "fadeInRegion",
                        start: this.positions.fadeInStart / 1000,
                        end: this.positions.fadeInStop / 1000,
                        drag: false,
                        resize: true,
                        color: "var(--COLOR_TRANSPARENT_INTRO)",
                    });
                this.wavesurfer.addRegion(
                    {
                        id: "fadeOutRegion",
                        start: this.positions.fadeOutStart / 1000,
                        end: this.positions.fadeOutStop / 1000,
                        drag: false,
                        resize: true,
                        color: "var(--COLOR_TRANSPARENT_EXTRO)"
                    })
                // remove possibility to add region manually
                this.wavesurfer.disableDragSelection();

                // remove all title attribute of generated regions
                // #todo, create a wavesurfer plugin to disable this on creating instance
                const allRegions = document.querySelectorAll(".wavesurfer-region");
                allRegions.forEach(e => {
                    e.setAttribute('title', '')
                });
            },
            createWaveForm() {
                // this.reset()
                if (!this.blob) return
                //console.log('createWaveForm');
                // if (this.wavesurfer) {
                // 	this.reset()
                // 	this.wavesurfer.destroy()
                // }
                this.wavesurfer = WaveSurfer.create({
                    container: this.$refs.waveform,
                    waveColor: '#888',
                    progressColor: this.primaryColor,
                    cursorColor: this.primaryColor,
                    barWidth: 3,
                    barGap: 0.5,
                    height: 160,
                    barHeight: 0.85,
                    autoCenter: false,
                    forceDecode: true,
                    //minPxPerSec: 4,
                    //scrollParent: true,
                    responsive: true,
                    plugins: [
                        // WaveSurfer.minimap.create({
                        //    container: '#map',
                        //    waveColor: 'grey',
                        //    progressColor: 'black',
                        //    height: 30
                        //}),
                        CursorPlugin.create({
                            showTime: true,
                            opacity: 0.9,
                            customShowTimeStyle: this.cursorStyle
                        }),
                        RegionPlugin.create({
                            regions: [],
                            dragSelection: {
                                slop: 5
                            }
                        }),
                        TimelinePlugin.create({
                            container: '#wave-timeline'
                        })
                    ]
                })
                this.wavesurfer.on('ready', () => {
                    this.waveIsReady = true
                    // Init pixel
                    this.secondsPerPixel = this.getSecondsPerPixel()
                    var that = this;
                    this.initRegions();

                    // Listen : wavesurfer events
                    this.wavesurfer.on('audioprocess', this.updateVolume.bind(this))
                    this.wavesurfer.on('pause', () => this.$emit('paused'))

                    // Listen : wavesurfer scroll event
                    this.$refs.waveform.querySelector('wave').addEventListener('scroll', this.onWaveFormScroll.bind(this))

                    // Listen : region update
                    this.wavesurfer.on('region-update-end', (region) => {
                        // Allow region update from other events
                        this.enableRegionRefresh = true;
                        this.emitPositionChanged();
                    });
                    this.wavesurfer.on('region-updated', (region) => {
                        // disable region update from other events
                        this.enableRegionRefresh = false;
                        //console.log(region.id, region.start, region.end)
                        if (region.id === "fadeInRegion") {
                            this.positions.fadeInStart = region.start * 1000;
                            this.positions.fadeInStop = region.end * 1000;
                        }
                        if (region.id === "fadeOutRegion") {
                            this.positions.fadeOutStart = region.start * 1000;
                            this.positions.fadeOutStop = region.end * 1000;
                        }
                    });

                    // listen : resize event
                    window.addEventListener('resize', this.onWindowResize.bind(this), false)

                    this.dragData.enableRegionRefresh = true;

                    // init fade line
                    this.drawFadeLine()

                    // Config is ready
                    this.$emit('ready', this.wavesurfer)
                })

                this.wavesurfer.loadBlob(this.blob)
            },
            setRaw(val) {
                this.isRaw = val
            },

            // Returns the width of the waveform
            getWidth() {
                return this.$refs.waveform.querySelector('wave').scrollWidth
            },
            // Returns the duration/pixel
            getSecondsPerPixel() {
                const waveFormContainer = this.$refs.waveform.querySelector('wave')
                const scrollWidth = waveFormContainer.scrollWidth
                const duration = this.wavesurfer.getDuration()
                return duration / scrollWidth
            },

            updateVolume() {
                this.$emit('audioprocess', this.wavesurfer.getCurrentTime() * 1000)
                const currentPos = this.wavesurfer.getCurrentTime() * 1000
                let volume = 0
                if (this.isRaw) {
                    volume = 1
                    this.wavesurfer.setVolume(volume)
                    return
                }
                if (currentPos > this.positions.fadeInStart && currentPos < this.positions.fadeInStop) {
                    const fadeOffset = currentPos - this.positions.fadeInStart
                    volume = fadeOffset / (this.positions.fadeInStop - this.positions.fadeInStart)
                } else if (currentPos >= this.positions.fadeInStop && currentPos < this.positions.fadeOutStart) {
                    volume = 1
                } else if (currentPos >= this.positions.fadeOutStart && currentPos < this.positions.fadeOutStop) {
                    const fadeOffset = this.positions.fadeOutStop - currentPos
                    volume = fadeOffset / (this.positions.fadeOutStop - this.positions.fadeOutStart)
                }
                this.wavesurfer.setVolume(volume)
            },
            stop() {
                this.wavesurfer.stop()
            },
            seek(val) {
                this.wavesurfer.skip(val / 1000)
            },
            pickTime() {
                return this.wavesurfer.getCurrentTime() * 1000;
            },
            setFadeOut() {
                // INTRO > fade in start
                const candidate = this.pickTime();
                this.positions.fadeOutStop = candidate
                if (this.positions.fadeOutStart > candidate) {
                    this.positions.fadeOutStop = this.positions.fadeOutStart;
                }
                this.$emit('positions-changed', this.positions)
            },
            setFadeIn() {
                // INTRO > fade in start
                const candidate = this.pickTime();
                this.positions.fadeInStart = candidate
                if (candidate > this.positions.fadeInStop) {
                    this.positions.fadeInStart = this.positions.fadeInStop;
                }
                this.$emit('positions-changed', this.positions)
            },
            setIntro() {
                // INTRO > fade in stop
                const candidate = this.pickTime();
                this.positions.fadeInStop = candidate
                if(this.positions.fadeInStop > this.positions.fadeOutStart){
                    this.positions.fadeInStop = this.positions.fadeOutStart - 100
                }
                // Check and correct start of fadeIn if needed
                if (this.positions.fadeInStart > candidate) {
                    this.positions.fadeInStart = candidate;
                }
                this.$emit('positions-changed', this.positions)
            },
            setOutro() {
              console.log('setOutro')
                this.positions.fadeOutStart = this.pickTime();
                if(this.positions.fadeOutStart < this.positions.fadeInStop){
                    this.positions.fadeOutStart = this.positions.fadeInStop + 100
                }
                this.$emit('positions-changed', this.positions)
            },
            setCue() {
                this.positions.cue = this.pickTime();
            },
            setMixPoint() {
                this.positions.mixPoint = this.pickTime();
                this.$emit('positions-changed', this.positions)
            },

            playIntro() {
                this.wavesurfer.play(this.positions.fadeInStart / 1000)
            },
            playOutro() {
                this.wavesurfer.play(this.positions.fadeOutStart / 1000)
            },
            playPause(e) {
                this.wavesurfer.playPause()
            },
            playCue() {
                this.wavesurfer.play((this.positions.cue / 1000))
            },
            zoom(pxPerSecond) {
                this.wavesurfer.zoom(pxPerSecond)
                this.secondsPerPixel = this.getSecondsPerPixel()
                this.$refs.mixpoints.width = this.$refs.waveform.querySelector('wave').scrollWidth + 'px'
                this.drawFadeLine()
            },
            scrollBy(scrollRatio) {
                console.log("WaveForm scrollBy", scrollRatio);
                const waveFormContainer = this.$refs.waveform.querySelector('wave')
                const mixPoints = this.$refs.mixpoints
                const scrollWidth = waveFormContainer.scrollWidth
                waveFormContainer.scrollLeft = scrollWidth * scrollRatio
                mixPoints.style.left = -waveFormContainer.scrollLeft;
                this.drawFadeLine()
            },
            scrollTo(scrollLeft) {
                console.log("WaveForm scrollLeft");
                const waveFormContainer = this.$refs.waveform.querySelector('wave')
                const mixPoints = this.$refs.mixpoints
                waveFormContainer.scrollLeft = scrollLeft
                // console.log(mixPoints)
                mixPoints.style.left = -waveFormContainer.scrollLeft;
                this.drawFadeLine()

            },
            onWaveFormScroll(e) {
                const scrollLeftRatio = e.target.scrollLeft / e.target.scrollWidth
                const canvas = this.$refs.waveform.querySelector('canvas')
                canvas.style.left = -e.target.scrollLeft + "px"
                this.drawMixPoints()
                this.$emit('scroll', scrollLeftRatio, e.target.scrollLeft)
            },
            setupMixpointsOverlay() {
                const rect = this.$refs.waveform.querySelector('wave')
                this.$refs.mixpoints.width = rect.scrollWidth
                this.$refs.mixpoints.height = rect.querySelector('canvas').getBoundingClientRect().height - 10; // height seems to vary sometimes
            },
            getMixPointsCoordinates() {
                const cnv = this.$refs.mixpoints
                const pxPerSecond = (cnv.width / (this.wavesurfer.getDuration()))
                const fadeInStart = (this.positions.fadeInStart / 1000) * pxPerSecond
                const fadeInStop = (this.positions.fadeInStop / 1000) * pxPerSecond
                const fadeOutStart = (this.positions.fadeOutStart / 1000) * pxPerSecond
                const fadeOutStop = (this.positions.fadeOutStop / 1000) * pxPerSecond
                const cue = (this.positions.cue / 1000) * pxPerSecond
                const mixPoint = (this.positions.mixPoint / 1000) * pxPerSecond
                return {
                    fadeInStart,
                    fadeInStop,
                    fadeOutStart,
                    fadeOutStop,
                    cue,
                    mixPoint
                };
            },
            drawMixPoints() {
                if (!this.waveIsReady) return;
                const coords = this.getMixPointsCoordinates()
                this.drawRegions();
                // remove scroll left from map
                const item = this.$refs.waveform.querySelector('wave');
                this.fadeInDragHandle.style.left = (coords.fadeInStart - item.scrollLeft) + 'px';
                this.introDragHandle.style.left = (coords.fadeInStop - item.scrollLeft) + 'px';
                this.extroDragHandle.style.left = (coords.fadeOutStart - item.scrollLeft) + 'px';
                this.fadeOutDragHandle.style.left = (coords.fadeOutStop - item.scrollLeft) + 'px';
                this.cueDragHandle.style.left = (coords.cue - item.scrollLeft) + 'px';
                this.mixPointDragHandle.style.left = (coords.mixPoint - item.scrollLeft) + 'px';
            },
            drawFadeLine() {
                if (!this.waveIsReady) return;
                this.setupMixpointsOverlay();
                let cnv = this.$refs.mixpoints;

                if (!this.ctx) {
                    this.ctx = cnv.getContext('2d')
                }

                const coords = this.getMixPointsCoordinates()
                const bottom = cnv.height - 6.5;

                this.ctx.clearRect(0, 0, cnv.width, cnv.height);

                //cnv.width = cnv.width // why set same width of canvas ?
                this.ctx.beginPath();
                this.ctx.strokeStyle = 'red'
                this.ctx.strokeWidth = 1
                this.ctx.moveTo(0.5, bottom)
                this.ctx.lineTo(coords.fadeInStart, bottom)
                this.ctx.lineTo(coords.fadeInStop, 6.5)
                // this.ctx.lineTo(coords.intro, bottom)
                // this.ctx.lineTo(coords.fadeIn, 6.5)
                this.ctx.lineTo(coords.fadeOutStart - 3, 6.5)
                this.ctx.lineTo(coords.fadeOutStop - 3, bottom)
                this.ctx.lineTo(cnv.width, bottom)
                this.ctx.stroke();
                this.ctx.closePath();

                this.drawMixPoints();
                // this.drawRegions();
            },
            drawRegions() {
                if (this.dragData.enableRegionRefresh) {
                    var {fadeInRegion, fadeOutRegion} = this.wavesurfer.regions.list || {};
                    //console.log(fadeInRegion, fadeOutRegion)
                    //console.log(fadeInRegion.start, fadeInRegion.end, JSON.stringify(this.positions))
                    if (fadeInRegion) {
                        fadeInRegion.update({
                            start: this.positions.fadeInStart / 1000,
                            end: this.positions.fadeInStop / 1000
                        })
                    }
                    if (fadeOutRegion) {
                        fadeOutRegion.update({
                            start: this.positions.fadeOutStart / 1000,
                            end: this.positions.fadeOutStop / 1000
                        })
                    }
                }
            },
            cancelDragImage(e) {
                let pixel = document.getElementById('dummypixel')
                if (!pixel) {
                    pixel = document.createElement('canvas')
                    pixel.id = 'dummypixel'
                    pixel.width = 1
                    pixel.height = 1
                    pixel.style.position = 'absolute'
                    document.body.appendChild(pixel)
                }

                e.dataTransfer.setDragImage(pixel, 0, 0)
            },

            onWindowResize() {
                this.drawFadeLine()
            },
            cueDragStart(e) {
                this.cancelDragImage(e)
                this.dragData.startPos = e.clientX
                this.origCue = this.positions.cue
            },
            mixPointDragStart(e) {
                this.cancelDragImage(e)
                this.dragData.startPos = e.clientX
                this.origMixPoint = this.positions.mixPoint
            },
            mixPointDrag(e) {
                const delta = this.dragData.clientX - this.dragData.startPos
                const seconds = delta * this.secondsPerPixel
                let mixPosition = Math.max(0, this.origMixPoint + seconds * 1000)
                this.positions.mixPoint = Math.min(this.wavesurfer.getDuration() * 1000, mixPosition)
                this.$emit('mixpointmove')
            },
            cueDrag(e) {
                const delta = this.dragData.clientX - this.dragData.startPos
                const secondsPerPixel = this.getSecondsPerPixel()
                const seconds = delta * secondsPerPixel
                this.positions.cue = Math.max(0, this.origCue + seconds * 1000)
                this.positions.cue = Math.min(this.wavesurfer.getDuration() * 1000, this.positions.cue)
            },
            fadeInDragStart(e) {
                this.cancelDragImage(e)
                this.dragData.startPos = e.clientX
                this.origFadeIn = this.positions.fadeInStart
            },
            introDragStart(e) {
                this.cancelDragImage(e)
                this.dragData.startPos = e.clientX
                this.origIntro = this.positions.fadeInStop

                var logs = [];
                logs.push("WaveForm > introDragStart")
                logs.push(">  From : " + e.clientX)
                logs.push(">  Element : " + e.currentTarget)
                logs.push(">  DragData : " + this.dragData)
                logs.push(">  StartPos : " + this.dragData.startPos)
                logs.push(">  OrigIntro : " + this.origIntro)
                logs.push(">  SecondsPerPixel : " + this.secondsPerPixel)
                this.dragData.logs = {
                    start: logs
                };

                this.$emit('intromove') // What for ?
            },
            introDrag(e) {
                const delta = this.dragData.clientX - this.dragData.startPos
                const seconds = delta * this.secondsPerPixel
                this.positions.fadeInStop = Math.max(this.positions.fadeInStart, this.origIntro + (seconds * 1000))
                this.positions.fadeInStop = Math.round(Math.min(this.positions.fadeInStop, this.positions.fadeOutStart))
                var logs = [];
                logs.push(">  Origin : " + this.origIntro)
                logs.push(">  Element : " + e.currentTarget)
                logs.push(">  DragData : " + this.dragData)
                logs.push(">  StartPos : " + this.dragData.startPos)
                logs.push(">  OrigIntro : " + this.origIntro)
                logs.push(">  SecondsPerPixel : " + this.secondsPerPixel)
                this.dragData.logs = {
                    drag: logs
                };
            },
            fadeInDrag(e) {
                console.log('drag fade in');
                // console.log("WaveForm > introDrag", this.dragData.clientX, this.dragData.startPos); // OK
                const delta = this.dragData.clientX - this.dragData.startPos
                const seconds = delta * this.secondsPerPixel
                this.positions.fadeInStart = Math.max(0, this.origFadeIn + (seconds * 1000))
                this.positions.fadeInStart = Math.min(this.positions.fadeInStart, this.positions.fadeInStop)

                var logs = [];
                logs.push(">  Origin : " + this.origFadeIn)
                logs.push(">  Element : " + e.currentTarget)
                logs.push(">  DragData : " + this.dragData)
                logs.push(">  StartPos : " + this.dragData.startPos)
                logs.push(">  OrigFadeIn : " + this.origFadeIn)
                logs.push(">  SecondsPerPixel : " + this.secondsPerPixel)
                this.dragData.logs = {
                    drag: logs
                };
            },
            fadeOutDragStart(e) {
                this.cancelDragImage(e)
                this.dragData.startPos = e.clientX
                this.origFadeOut = this.positions.fadeOutStop
            },
            extroDragStart(e) {
                this.cancelDragImage(e)
                this.dragData.startPos = e.clientX
                this.origExtro = parseFloat(this.positions.fadeOutStart)
            },
            extroDrag(e) {
              console.log('extroDrag' , e)
                let delta = this.dragData.clientX - this.dragData.startPos
                const seconds = delta * this.secondsPerPixel
                this.positions.fadeOutStart = Math.max(this.positions.fadeInStop, this.origExtro + (seconds * 1000))
                // TODO: check why there is a 1800 ms discrepancy here ????!!!!???
                // best guess: the width of the fadeout drag point (10px) pushes the container's right boundary thus extending it's width and corrupting the 'pixelsperseconds' value
                this.positions.fadeOutStart = Math.min(this.positions.fadeOutStart, this.positions.fadeOutStop)
            },


            fadeOutDrag(e) {
                const delta = this.dragData.clientX - this.dragData.startPos
                const seconds = delta * this.secondsPerPixel
                this.positions.fadeOutStop = Math.max(this.positions.fadeOutStart, this.origFadeOut + (seconds * 1000))
                this.positions.fadeOutStop = Math.round(Math.min(this.positions.fadeOutStop, this.wavesurfer.getDuration() * 1000))
            }
        }
    };
</script>
